import useSWR from "swr";
import axios from "../api/axios";

export interface AdminContentPartOption {
  id: string;
  title: string;
  order: number;
}

async function fetchContentParts(contentId: string): Promise<AdminContentPartOption[]> {
  try {
    const res = await axios.get(`/contentpart/content/${contentId}`);
    const list: AdminContentPartOption[] = Array.isArray(res.data)
      ? res.data.map((part: any) => ({
          id: part.id ?? part.Id ?? "",
          title: part.title ?? part.Title ?? "Bölüm",
          order: part.order ?? part.Order ?? 0,
        }))
      : [];
    return list;
  } catch (error) {
    console.error("[admin] content parts load failed", error);
    return [];
  }
}

export default function useAdminContentParts(contentId: string | null) {
  return useSWR<AdminContentPartOption[]>(contentId ? ["admin-content-parts", contentId] : null,
    () => fetchContentParts(contentId!),
    { revalidateOnFocus: false },
  );
}
